/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import Cookies from 'js-cookie';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { REDIRECT_ROUTES } from '../../constants';

import { useAuth } from '../context';

function RedirectRoute({ from, noRedirect }) {
  const { user, authFrozen } = useAuth();
  const location = useLocation();
  function generatePathname() {
    if (authFrozen) {
      return REDIRECT_ROUTES.USER_FROZEN;
    }
    if (window.location.pathname === '/' && !Cookies.get('sila_console_registered')) {
      return REDIRECT_ROUTES.REGISTER;
    }
    if (from) return from;
    if (user) {
      if (window.location.href.includes('admin.silamoney.com') && user.is_superuser) {
        return REDIRECT_ROUTES.ADMIN_HOME;
      }
      return REDIRECT_ROUTES.USER_HOME;
    }
    return '/login';
  }

  let newState;
  if (!noRedirect) {
    if (location.state) {
      newState = { ...location.state };
    } else {
      newState = { from: location.pathname, search: location.search };
    }
  }

  return (
    <Navigate
      to={{
        pathname: generatePathname(),
        state: newState,
      }}
    />
  );
}

RedirectRoute.propTypes = {
  /**
   * The url to be redirected back to, if specified
   */
  from: PropTypes.string,
  /**
   * The redirect boolean to force a redirect, or not
   */
  noRedirect: PropTypes.bool,
};

export default RedirectRoute;
